module.exports = __webpack_public_path__ + "img/eye-infinite-player.ebbd1140.webp";